<template>
    <div id="content" class="sub">
        <div class="grid--con-sub">
            <ul class="i5gam-support-list __grid--3">
                <li>
                    <div class="box-type04 __center">
                        <div class="icon-support-list">
                            <img src="../../../../assets/i5gam/images/icon-support-list01.png" />
                        </div>
                        <div class="__txt">상담 대표번호
                          <span class="pc02" v-if="mberInfo.jkUseAt == 'Y'">1899-8255</span>
                          <span class="pc02" v-else>1661-5029</span>
                          로 통화 연결 후,<br/>상담원에게 원격지원을 요청하세요.
                        </div>
                    </div>
                    <div style="position:absolute;top:65px;right:-60px;z-index:9;">
                        <img style="width:65%;height:65%;opacity: 0.2;" src="../../../../assets/i5gam/images/icon-support-list-next.png" />
                    </div>
                </li>
                <li>
                    <div class="box-type04 __center">
                        <div class="icon-support-list">
                            <img src="../../../../assets/i5gam/images/icon-support-list02.png" />
                        </div>
                        <div class="__txt">하단의 <span class="pc02">[원격지원 시작]</span> 버튼을 눌러주세요.</div>
                    </div>
                    <div style="position:absolute;top:65px;right:-60px;z-index:9;">
                        <img style="width:65%;height:65%;opacity: 0.2;" src="../../../../assets/i5gam/images/icon-support-list-next.png" />
                    </div>
                </li>
                <li>
                    <div class="box-type04 __center">
                        <div class="icon-support-list">
                            <img src="../../../../assets/i5gam/images/icon-support-list03.png" />
                        </div>
                        <div class="__txt">상담원에게 안내 받은 <span class="pc02">번호</span>를 선택해주세요.</div>
                    </div>
                </li>
            </ul>
            <div class="btn-wrap t-line __center mgt40">
                <button class="big _bt-ypurple" @click="btn_remoteStart()"><span>원격지원 시작</span></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'remoteSupport',
    data : function(){
        return{
            csTabList : [
                {tabNm : '공지사항', uri : 'views.i5gam.cs.notice'},
                {tabNm : 'FAQ', uri : 'views.i5gam.cs.faq'},
                {tabNm : '1:1 문의', uri : 'views.i5gam.cs.qstn'},
                {tabNm : '원격지원', uri : 'views.i5gam.cs.remoteSupport'},
            ],
        }
    },
    computed : {
      mberInfo : function (){
        return this.$store.getters.getMberInfo;
      }
    },
    methods : {
        btn_remoteStart : function(){
            var url = "http://113366.com/onandon";
			var name = "i5gamRemote";
			
			window.open(url, name);
        },
    },
    mounted : function(){
        
    }
}
</script>